import { Box, Grid } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useMemo, useState } from 'react';
import { EventTicketsDataGridFilter } from './eventTicketsDataGridFilter';
import { EventTicketsDataGrid } from './eventTicketsDataGrid';
import { EventTicket } from '../models/eventTicket';
import { EventParticipantTicketSearchFilter } from '../models/eventParticipantTicketSearchFilter';

type EventDetailTabTicketsProps = {
  tickets: EventTicket[];
  eventId: number;
};

export const EventDetailTabTickets = (props: EventDetailTabTicketsProps) => {
  const { tickets, eventId } = props;
  const { t } = useTranslation();
  const [searchFilter, setSearchFilter] = useState<EventParticipantTicketSearchFilter>({
    searchString: '',
    selectedTicketTypes: tickets,
  });

  const memoizedSearchFilter: EventParticipantTicketSearchFilter = useMemo(() => {
    return {
      searchString: searchFilter.searchString,
      selectedTicketTypes: searchFilter.selectedTicketTypes,
    };
  }, [searchFilter.searchString, searchFilter.selectedTicketTypes]);

  return (
    <>
      <GridWrapper>
        <Grid item xs={12}>
          <ContentSection header={t('event:tickets')}>
            <Box sx={{ pt: 1 }}>
              <EventTicketsDataGridFilter tickets={tickets} searchFilter={searchFilter} setSearchFilter={setSearchFilter} />
              <EventTicketsDataGrid searchFilter={memoizedSearchFilter} eventId={eventId} />
            </Box>
          </ContentSection>
        </Grid>
      </GridWrapper>
    </>
  );
};
